export default __webpack_public_path__ + "static/media/home.5a040647.svg";